import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Navbar from './components/navbar/Navbar';
import AddForm from './pages/AddForm';
import Home from './pages/Home';
import './App.css';

function App() {
  return (
    <>
    <Navbar />
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/form' element={<AddForm />}/>
      <Route path='/edit/:jobId' element={<AddForm />}/>
    </Routes>
    </>
  );
}

export default App;
